import { Handle } from 'react-flow-renderer';

const FileNode = ({ data }) => {
    const customNodeStyles = {
        background: 'white',
        color: '#222',
        padding: '10px',
        width: 'fit-content',
        fontSize: '10px',
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        border: 'none',
        marginTop: '0.1rem',
    };

    return (
        <>
            <div style={customNodeStyles}>
                <Handle type="source" position="left" style={{ background: '#EB8C00' }} />
                <Handle type="target" position="right" style={{ background: '#EB8C00' }} />
                <span
                    className="appkiticon icon-news-outline"
                    style={{ fontSize: '2rem', paddingLeft: '0.35rem' }}
                />
            </div>
            <div style={{ marginBottom: '0.1rem' }}>
                {data.label}
            </div>
        </>
    );
};

export default FileNode;
